import React, { useEffect, useState } from "react";
import "./Popup.css";
import { useProperty } from "../../../../PropertyContext";
import { ReserBusinessSource } from "../../../../Services/Service";

const SourcePopup = ({ show, onClose, onSelect }) => {
  const { selectedProperty } = useProperty();
  const [businessSources, setBusinessSources] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    const fetchBusinessSource = async () => {
      if (!selectedProperty?.PropertyID) {
        setBusinessSources([]);
        return;
      }

      setLoading(true);
      try {
        const data = await ReserBusinessSource(selectedProperty?.PropertyID);
        setBusinessSources(Array.isArray(data) ? data : []);
      } catch (error) {
        console.log("Error fetching business sources:", error);
        setBusinessSources([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBusinessSource();
  }, [selectedProperty]);

  useEffect(() => {
    if (!show) return undefined;
    setSearchText("");
    setSelectedId(null);

    const handleEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [show, onClose]);

  if (!show) return null;

  const searchValue = searchText.replace(/\*/g, "").trim().toLowerCase();
  const filteredSources = businessSources.filter((source) =>
    `${source.Code ?? ""} ${source.BusinessSource ?? ""} ${
      source.BONBusinessSource ?? ""
    }`
      .toLowerCase()
      .includes(searchValue),
  );
  const selectedSource = businessSources.find(
    (source) => source.ID === selectedId,
  );

  return (
    <div
      id="sourcePopupBackdrop"
      className="bon-lookup-backdrop"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        id="sourcePopup"
        className="modal-dialog modal-dialog-centered bon-lookup-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="sourcePopupTitle"
      >
        <div className="modal-content">
          <div className="modal-header bon-lookup-header">
            <h5 id="sourcePopupTitle" className="modal-title">
              Search and Select Source
            </h5>
            <button
              type="button"
              className="btn-close bon-popup-close"
              aria-label="Close source popup"
              onClick={onClose}
            />
          </div>

          <div className="modal-body">
            <div className="input-group bon-popup-search">
              <input
                id="sourceSearchInput"
                type="search"
                className="form-control"
                placeholder="Use (*) for wildcard search"
                value={searchText}
                onChange={(event) => setSearchText(event.target.value)}
                autoFocus
              />
              <button type="button" className="btn bon-search-button">
                Search
              </button>
            </div>

            <div className="table-responsive bon-popup-table-wrap">
              <table className="table table-sm table-hover mb-0 bon-popup-table">
                <thead>
                  <tr>
                    <th scope="col">Code</th>
                    <th scope="col">Description</th>
                  </tr>
                </thead>
                <tbody>
                  {!loading &&
                    filteredSources.map((source) => (
                    <tr
                      id={`source-row-${source.ID}`}
                      key={source.ID}
                      className={
                        selectedId === source.ID ? "bon-row-selected" : ""
                      }
                      onClick={() => setSelectedId(source.ID)}
                      onDoubleClick={() => onSelect(source)}
                    >
                      <td>{source.Code}</td>
                      <td>
                        {source.BusinessSource || source.BONBusinessSource}
                      </td>
                    </tr>
                  ))}
                  {loading && (
                    <tr>
                      <td colSpan="2" className="text-center py-4">
                        Loading sources...
                      </td>
                    </tr>
                  )}
                  {!loading && !filteredSources.length && (
                    <tr>
                      <td colSpan="2" className="text-center py-4">
                        No matching source found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="modal-footer bon-lookup-footer">
            <button
              type="button"
              className="btn bon-cancel-button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              id="selectSourceButton"
              type="button"
              className="btn bon-select-button"
              disabled={!selectedSource}
              onClick={() => onSelect(selectedSource)}
            >
              Select
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SourcePopup;
